import { render, staticRenderFns } from "./provider-table.vue?vue&type=template&id=67c52333&scoped=true&"
import script from "./provider-table.ts?vue&type=script&lang=ts&"
export * from "./provider-table.ts?vue&type=script&lang=ts&"
import style0 from "./provider-table.scss?vue&type=style&index=0&id=67c52333&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c52333",
  null
  
)

export default component.exports